export const QuickSearchTagIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" fill={color} r="5" />
    </svg>
  );
};
